import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function ReparationFenetreBoisLyon() {
  const services = [
    {
      icon: 'ri-plant-line',
      title: 'Traitement du Bois',
      description: 'Traitement anti-humidité, anti-insectes et anti-champignons pour préserver vos fenêtres.',
      price: 'À partir de 120€'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Rénovation Menuiserie',
      description: 'Réparation de cadres, remplacement de parties abîmées, consolidation structurelle.',
      price: 'À partir de 150€'
    },
    {
      icon: 'ri-brush-line',
      title: 'Peinture & Finitions',
      description: 'Décapage, ponçage, lasure ou peinture pour redonner vie à vos fenêtres bois.',
      price: 'À partir de 100€'
    },
    {
      icon: 'ri-window-2-line',
      title: 'Remplacement Vitrage',
      description: 'Pose de double vitrage sur fenêtres anciennes pour améliorer l\'isolation.',
      price: 'À partir de 160€'
    },
    {
      icon: 'ri-ancient-gate-line',
      title: 'Conservation Patrimoine',
      description: 'Restauration de fenêtres anciennes dans le respect du patrimoine lyonnais.',
      price: 'Sur devis'
    },
    {
      icon: 'ri-shield-line',
      title: 'Étanchéité Complète',
      description: 'Remplacement de joints, traitement anti-infiltration et isolation optimale.',
      price: 'À partir de 80€'
    }
  ];

  const woodTypes = [
    {
      name: 'Chêne',
      description: 'Bois noble et résistant, idéal pour la durabilité',
      icon: 'ri-leaf-line'
    },
    {
      name: 'Pin',
      description: 'Bois économique et facile à travailler',
      icon: 'ri-plant-line'
    },
    {
      name: 'Méranti',
      description: 'Bois exotique résistant aux intempéries',
      icon: 'ri-seedling-line'
    },
    {
      name: 'Bois Massif',
      description: 'Toutes essences nobles pour restauration',
      icon: 'ri-tree-line'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-amber-600 via-orange-500 to-amber-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-map-pin-line text-white"></i>
              <span className="text-white text-sm font-medium">Lyon - Spécialiste Menuiserie Bois</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Réparation Fenêtre Bois Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Artisan spécialisé en réparation et restauration de fenêtres bois à Lyon. Traitement du bois, rénovation complète et conservation du patrimoine. Redonnez vie à vos fenêtres anciennes.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-amber-600 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Devis Gratuit
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="tel:0478XXXXXX"
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                04 78 XX XX XX
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-amber-600 font-semibold text-xs uppercase tracking-wider">
              ARTISAN MENUISIER
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
              Services de Réparation Fenêtre Bois
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Expertise artisanale pour préserver et restaurer vos fenêtres en bois
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-amber-500 to-orange-400 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="pt-4 border-t border-gray-100">
                  <span className="text-amber-600 font-bold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Wood Types */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Essences de Bois Traitées
            </h2>
            <p className="text-gray-600 text-lg">
              Expertise sur toutes les essences de bois
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {woodTypes.map((wood, index) => (
              <div key={index} className="text-center bg-amber-50 rounded-2xl p-8 hover:shadow-lg transition-all">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${wood.icon} text-amber-600 text-3xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  {wood.name}
                </h3>
                <p className="text-gray-600 text-sm">
                  {wood.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Artisan Réparation Fenêtre Bois Lyon
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Spécialiste de la <strong>réparation de fenêtres bois à Lyon</strong>, nous redonnons vie à vos menuiseries anciennes tout en préservant leur charme authentique. Notre savoir-faire artisanal nous permet d'intervenir sur tous types de fenêtres en bois, des plus modernes aux plus anciennes.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Les Avantages des Fenêtres en Bois
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              Le bois reste un matériau noble et chaleureux, particulièrement apprécié dans les immeubles anciens de Lyon. Les fenêtres en bois offrent une excellente isolation thermique et phonique, un charme authentique incomparable, et la possibilité de restauration complète. Contrairement aux idées reçues, une fenêtre bois bien entretenue peut durer plusieurs décennies.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nos Prestations de Réparation
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Traitement préventif :</strong> Protection contre l'humidité, les insectes et les champignons</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Réparation structurelle :</strong> Remplacement de parties abîmées, consolidation des cadres</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Rénovation esthétique :</strong> Décapage, ponçage, lasure ou peinture professionnelle</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Amélioration thermique :</strong> Pose de double vitrage sur fenêtres anciennes</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-amber-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Restauration patrimoine :</strong> Conservation des fenêtres d'immeubles classés</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Conservation du Patrimoine Lyonnais
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Lyon possède un riche patrimoine architectural avec de nombreux immeubles anciens dotés de fenêtres en bois d'époque. Nous sommes spécialisés dans la restauration de ces menuiseries historiques, en respectant les techniques traditionnelles et les contraintes des Bâtiments de France. Notre expertise permet de conserver l'authenticité tout en améliorant les performances énergétiques.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Intervention à Lyon et sa Région
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous intervenons dans tout Lyon (Vieux-Lyon, Presqu'île, Croix-Rousse, etc.) et sa région pour la réparation et la restauration de fenêtres en bois. Devis gratuit et conseils personnalisés pour chaque projet.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
